import * as React from "react";
import { EntityType } from '../../../models/EntityType';
import { NavLink } from 'react-router-dom';

import { routeFor } from '../../routes';

interface Props
{
    type: EntityType,
    to: string
}
export const EntityLink: React.StatelessComponent<any> = ({ type, children }) => {
  return (<NavLink to={routeFor(type)}>{children}</NavLink>);
};



// WEBPACK FOOTER //
// ./src/app/components/Header/EntityLink.tsx